import { jsx as _jsx } from "react/jsx-runtime";
// Career Miniapp — I18n Provider
// Egyetlen forrás: a /api/jobs/site-config translations.system + translations.client
import React, { createContext, useContext } from 'react';
const I18nContext = createContext(null);
export function I18nProvider({ value, children }) {
    return _jsx(I18nContext.Provider, { value: value, children: children });
}
export function useI18nContext() {
    const ctx = useContext(I18nContext);
    if (!ctx)
        throw new Error('useI18nContext must be used inside I18nProvider');
    return ctx;
}
